import React, {Component} from "react";
import AttributeService from "../../../services/attributes-service";
import {Button, Table} from "reactstrap";
import LoadingSm from "../../../common/Loading/Loading-sm";

/**
 * Incoming values
 * <ul>
 *     <li>account
 */
class Attributes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attributes: [{name: "", value: ""}]
        }
    }

    /**
     * Setup the list of all possible attributes for all possible products.
     */
    componentDidMount() {
        let atts = Object.entries(AttributeService.descriptionMap).map(item => {
            return {name: item[0], description: item[1]}
        });

        this.setState({
            attributes: atts
        });
    }


    populateTable = () => {
        //Don't display the company id or DisplayName attributes.
        return this.state.attributes.map((attribute, i) => {
            let attValue = "";
            if (this.props.account.attributes) {
                attValue = this.props.account.attributes.find(a => a.name === attribute.name);
                if (attValue) {
                    attValue = attValue.value;
                }
            }
            return (
                <tr key={i}>
                    <td className="width-20">{attribute.name}</td>
                    <td className="width-20">
                        <input id={attribute.name} name={attribute.name} value={attValue || ''}
                               onChange={this.props.handleAttributeChange}/>
                    </td>
                    <td className="width-60">{attribute.description}</td>
                </tr>
            );
        });
    };



    render() {
        return (
            <div className="account-products-wrapper">
                <div style={{padding: 5 + 'px'}} className="generate-key-container">
                    <Button
                        type="button"
                        className="btn btn-success"
                        onClick={() => this.props.updateAccount(this.props.account)}
                    >Save</Button>{this.props.isSaving && <LoadingSm/>}
                </div>
                <div className="attributes-table">

                    <Table className="table">
                        <thead>
                        <tr>
                            <th className="width-20">Name</th>
                            <th className="width-20">Value</th>
                            <th className={`${this.props.isActive ? "width-50" : "width-60"}`}>Description</th>
                        </tr>
                        </thead>
                        <tbody>{this.populateTable()}</tbody>
                    </Table>
                </div>
            </div>
        )
    }
}

export default Attributes;


// WEBPACK FOOTER //
// ./src/accounts/account-details/components/Attributes.js